import React, { useEffect } from 'react'
import FaqPage from './home/faq';
import { Footer } from '../components/footer';
import Aos from "aos";

const FAQPage = () => {
    useEffect(() => {
        window.scrollTo(0, 0);
        Aos.init({ once: true });
     }, []);
    return (
        <>
        <div className="mainContent">
            <div className="pageContent py-5">
                <div className="container">
                    <div className="row justify-content-center mb-5">
                        <div className="col-lg-6">
                            <div className="secHead text-center">
                                <h4>FAQ </h4>
                                <h2 className='mb-2'>Frequently Asked Questions</h2>
                                <p> It has survived not only five centuries, but also the leap into electronic typesetting, remaining essentially unchanged.</p>
                            </div>
                        </div>
                    </div>
                    <div className="row justify-content-center">
                        <div className='col-lg-10'>
                            <FaqPage />
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <Footer />
        </>
    )
}

export default FAQPage;